import { gql } from "@apollo/client";

export const GET_INTEGRATIONS = gql`
    query Integrations($input: QueryIntegrationsInput!) {
        integrations(input: $input) {
           id
           name
           description
           callback_uri
           connections {
            id
           }
        }
    }
`;

export const GET_STRIPE_PUBLIC_KEY = gql`
  query StripePublicKey {
    stripePublicKey {
      config
    }
  }
`;

export const GET_STRIPE_INTEGRATION = gql`
  query StripeIntegration($input: QueryStripeIntegrationInput!) {
    stripeIntegration(input: $input) {
      id
      enabled
      description
      name
      config
    }
  }
`;
